import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import GA from "./_utils/GoogleAnalytics";

import registerServiceWorker from "./registerServiceWorker";

import "./style-layout.css";
import "./style-reset.css";
import "./general.css";
import "./fonts.css";
import reducers from "./_reducers";
import App from "./App";
import BrowserNotSupported from "./views/BrowserNotSupported";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));
const store = createStore(reducers, {}, enhancer);

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#fa4c2e",
            main: "#bf0000",
            dark: "#870000",
            contrastText: "#fff"
        },
        secondary: {
            light: "#2c2c2c",
            main: "#000",
            dark: "#000",
            contrastText: "#fff"
        }
    },
    shape: {
        borderRadius: 0
    },
    overrides: {
        MuiBackdrop: {
            root: {
                backgroundColor: "none"
            }
        },
        MuiDialog: {
            root: {
                alignItems: "baseline",
                marginTop: "40px"
            }
        }
    }
});

const browser = require("@browser-detection");

if (browser.name === "IE") {
    ReactDOM.render(<BrowserNotSupported />, document.getElementById("root"));
} else {
    ReactDOM.render(
        <Provider store={store}>
            <BrowserRouter basename={process.env.REACT_APP_BASE_URL} forceRefresh={!("pushState" in window.history)}>
                <MuiThemeProvider theme={theme}>
                    {/*GA.init() && <GA.RouteTracker />*/}
                    <App />
                </MuiThemeProvider>
            </BrowserRouter>
        </Provider>,
        document.getElementById("root")
    );
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js